export default "__VITE_PUBLIC_ASSET__0371c01e__"